import React from 'react';
import { Paper, Typography, Box, useTheme } from '@mui/material';
import SummarizeIcon from '@mui/icons-material/Summarize';

type Props = { summary: string };

const ChatSearchSummary: React.FC<Props> = ({ summary }) => {
  const theme = useTheme();
  if (!summary) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        p: 1.5,
        mb: 2,
        borderRadius: 1,
        borderLeft: `3px solid ${theme.palette.primary.main}`,
        backgroundColor: theme.palette.action.hover,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <SummarizeIcon color="primary" sx={{ fontSize: '1.1rem' }} />
        <Typography variant="subtitle2" fontWeight={600}>
          Summary
        </Typography>
      </Box>

      <Typography
        variant="body2"
        sx={{
          mt: 0.5,
          ml: 3, // indent under icon
          color: theme.palette.text.secondary,
          lineHeight: 1.5,
        }}
      >
        {summary}
      </Typography>
    </Paper>
  );
};

export default ChatSearchSummary;
